/**
 * 安卓存在兼容问题，暂时弃用
 */

import './list-view.scss'
import InfiniteScroll from './InfiniteScroll'
import RefreshControl from './RefreshControl'
import LoadMore from './LoadMore'
import ListView from './list-view.vue'

LoadMore.install = function (Vue) {
  Vue.component(LoadMore.name, LoadMore)
  Vue.component(RefreshControl.name, RefreshControl)
  Vue.component(InfiniteScroll.name, InfiniteScroll)
}

export { LoadMore, ListView }
export default LoadMore



// WEBPACK FOOTER //
// ./src/components/list-view/index.js